import SubTableFirstRow from 'app/backbone/components/tables/rows/sub_table/SubTableFirstRow.view';

export default class CompanyProfileFirstRow extends SubTableFirstRow {

    getSubTableCollection() {
        return this.model.getRelation('available_items');
    }

}
